(() => {
  function initAnnouncementBar(root) {
    const bars = (root || document).querySelectorAll('[data-ab]');
    bars.forEach((bar) => {
      // évite double init
      if (bar.dataset.abInit === '1') return;
      bar.dataset.abInit = '1';

      const mode = bar.getAttribute('data-mode') || 'slider';
      const autoplay = bar.getAttribute('data-autoplay') === 'true';
      const pauseHover = bar.getAttribute('data-pause-hover') === 'true';
      const interval = parseInt(bar.getAttribute('data-interval') || '4000', 10);

      const items = Array.from(bar.querySelectorAll('[data-ab-item]'));
      if (!items.length) return;

      // Si 1 seul message, on laisse statique
      if (items.length === 1 || mode === 'none' || !autoplay) {
        items.forEach((el, i) => el.classList.toggle('is-active', i === 0));
        return;
      }

      let index = items.findIndex((el) => el.classList.contains('is-active'));
      if (index < 0) index = 0;

      items.forEach((el, i) => el.classList.toggle('is-active', i === index));

      let timer = null;
      let paused = false;

      const next = () => {
        if (paused) return;
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      };

      const start = () => {
        stop();
        timer = window.setInterval(next, Math.max(1500, interval));
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      if (pauseHover) {
        bar.addEventListener('mouseenter', () => { paused = true; });
        bar.addEventListener('mouseleave', () => { paused = false; });
      }

      // Démarre
      start();

      // (Optionnel) si tu veux, tu peux exposer pour debug
      bar.__ab = { start, stop, next };
    });
  }

  // Init normal
  document.addEventListener('DOMContentLoaded', () => initAnnouncementBar(document));

  // Shopify Theme Editor: ré-init quand la section est rechargée
  document.addEventListener('shopify:section:load', (e) => initAnnouncementBar(e.target));
  document.addEventListener('shopify:section:select', (e) => initAnnouncementBar(e.target));
})();